var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"cell-line-one"},[_vm._v(_vm._s(_vm.result.movement.toFixed(2))+"%")]),_c('span',{staticClass:"cell-line-two"},[_vm._v(_vm._s(_vm.result.profit))])])}
var staticRenderFns = []

export { render, staticRenderFns }